module.exports = __webpack_public_path__ + "img/expiredIcon.5c9c7d3f.png";